import styled from 'styled-components'
import { breakpoints, colors } from '@/styles'
import { Label } from '@/components/text'
import useMediaQuery from '@/hooks/use-media-query'

const DashboardTitle = styled.div`
  flex: 1;
  min-width: 120px;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: ${colors.regular};
  gap: 0 8px;

  > h1 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  @media screen and (max-width: ${breakpoints.desktopSmall}) {
    padding: 0 20px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`

type Props = {
  children?: React.ReactNode
}

const DashboardHeaderTitle: React.FC<Props> = ({ children, ...rest }) => {
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  return (
    <DashboardTitle {...rest}>
      <Label id="header-title" as="h1" fontSize={!displayMobile ? '16px' : '14px'}>
        {children}
      </Label>
    </DashboardTitle>
  )
}

export default DashboardHeaderTitle
